<div>
  <!-- 閉じるボタン -->
  <button
    id="close-btn"
    class="!tw-absolute tw-top-1 tw-right-1 !tw-flex !tw-z-10"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon>close</mat-icon>
  </button>

  <form [formGroup]="formGroup" (submit)="submit()" class="tw-p-4">
    <div mat-dialog-title class="matp-dialog-title">
      <span class="absolute h-14 w-14 top-0 start-0">
        タグ設定(デバイスへのタグ追加/解除)
      </span>
    </div>

    <mat-dialog-content class="!tw-pt-2 tw-max-h-1/2">
      <div class="tw-mx-2 tw-ml-5">
        <span *ngIf="deviceName">デバイス名： {{ deviceName }}</span>
      </div>
      <div class="tw-flex tw-w-full tw-justify-around">
        <div class="tw-mx-2 tw-w-2/5">
          <p>設定情報(現在の設定情報も表示)</p>
          <mat-selection-list
            class="tw-border-solid tw-border-2 tw-h-80 tw-max-h-4/5 tw-overflow-y-auto tw-w-full"
            #deviceTags
          >
            @for (deviceTagRefs of deviceTagRefsList; track deviceTagRefs) {
              <mat-list-option
                [value]="deviceTagRefs"
                (click)="toggleDeviceTagSelection(deviceTagRefs)"
                [matTooltip]="deviceTagRefs['tagName']"
                ><span class="tw-rounded tw-p-1" [ngStyle]="tagStyle(deviceTagRefs['color'])">{{ deviceTagRefs["tagName"] }}</span></mat-list-option
              >
            }
          </mat-selection-list>
        </div>
        <div class="tw-flex tw-mx-2 tw-mt-14 tw-justify-center tw-items-center">
          <div class="tw-flex tw-flex-col tw-my-5">
            <button
              mat-raised-button
              class="tw-rounded tw-px-4 tw-py-2 tw-my-4 tw-mt-4"
              type="button"
              color="primary"
              (click)="moveToDeviceTagList(selectedTag)"
            >
              <div class="tw-grid tw-grid-cols-2">
                <mat-icon>keyboard_double_arrow_left</mat-icon>
                追加
              </div>
            </button>

            <button
              mat-raised-button
              class="tw-rounded tw-px-4 tw-py-2 tw-my-4"
              type="button"
              color="primary"
              (click)="moveToTagList(selectedDeviceTag)"
            >
              <div class="tw-grid tw-grid-cols-2">
                <mat-icon>keyboard_double_arrow_right</mat-icon>
                解除
              </div>
            </button>
          </div>
        </div>
        <div class="tw-mx-2 tw-w-2/5 tw-h-50">
          <p>タグ一覧</p>
          <mat-selection-list
            class="tw-border-solid tw-border-2 tw-h-80 tw-max-h-4/5 tw-overflow-y-auto tw-w-full"
            #tags
          >
            @for (tag of tagList; track tag) {
              <mat-list-option
                [value]="tag"
                (click)="toggleTagSelection(tag)"
                [matTooltip]="tag['tagName']"
                ><span class="tw-rounded tw-p-1" [ngStyle]="tagStyle(tag['color'])">{{ tag["tagName"] }}</span></mat-list-option
              >
            }
          </mat-selection-list>
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions class="tw-flex !tw-justify-center !tw-px-6 tw-gap-x-4">
      <button
        id="cancel-btn"
        mat-raised-button
        mat-dialog-close
        class="tw-w-40"
      >
        <mat-icon>close</mat-icon>
        キャンセル
      </button>
      <button
        id="edit-btn"
        mat-raised-button
        color="accent"
        class="tw-w-40"
        type="submit"
        [disabled]="formGroup.invalid"
      >
        <mat-icon>done</mat-icon>
        <span>変更</span>
      </button>
    </mat-dialog-actions>
  </form>
</div>
